import type { FaireProductEntity } from "../../entity_types/product";

export const p_c4z3xadpq7: FaireProductEntity = {
  token: "p_c4z3xadpq7",
  type: "product",
  name: "Vichy Catalan - Sparkling Water - 300ml(Case of 24)",
  brandToken: "b_bzxg32q5dk",
  brandName: "Alta Gama Foods",
  imageUrl:
    "https://cdn.faire.com/fastly/de36e9f3fce4ab1b0967104e63d4564db78e0b86dafaf86c8aaea018aa4d82be.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fb6f43fbd5d9cac7a0c9bc7fb505bdca49f3b2d1f0eeafc1e8f1abb4dd39ff1c.jpeg",
    "https://cdn.faire.com/fastly/ef82062904459c79ef5f3c98a7575d873d3d255e3c1920f220204d2ce8419f45.jpeg",
  ],
  priceDollars: 2.02,
  description:
    "Vichy Catalan was established in 1881. This premium water emerges from the ground at 60 degrees Celsius, which gives it a unique personality. The water is rich in minerals from the thermal waters of Caldes de Malavella, in the Selva comarca in Girona, Spain., This unique water is rich in minerals from the heart of the earth, containing27 of the 34 minerals that the human body needs for good health.Vichy Catalan is good for you:• Helps lower cholesterol and triglyceride levels• Promotes effective digestion due to its sodium bicarbonate content• Stimulates intestinal motility• Prevents tooth decay• Helps strengthen bone structure• It has antidepressant effects due to its lithium content• Excellent for rehydration after practicing any sport ",
  tags: [],
  msrpDollars: 4.05,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:16.216Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
